<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
<g id="Group 16159">
<circle id="Ellipse 5" cx="10" cy="10" r="9.25" fill="#327EEE" stroke="#327EEE" stroke-width="1.5"/>
<path id="Shape" d="M5 10.3636L8.63667 14L12.637 10L14.6372 8" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
</g>
</svg>
